<template>
  <div>
    <vx-card no-shadow title="Communications">
      <ACard>
        <a-tabs @change="changeTab">
          <span slot="tabBarExtraContent">
                <a-button type="primary"
                                 ghost
                                 @click="showDrawer"
                                 icon="filter"
                                 class="mt-5 md:mt-0"
                                 style="border-radius: 3px !important;"
                       >
                  Filters
                </a-button>
                 <a-dropdown v-if="hasPermission('communication.phone-log.create') || hasPermission('communication.email-log.create')">
                  <a-menu slot="overlay">
                    <a-menu-item v-if="hasPermission('communication.phone-log.create')" key="1" @click="addPhoneLog"> <a-icon type="phone" />Call log</a-menu-item>
                    <a-menu-item v-if="hasPermission('communication.email-log.create')" key="2" @click="addEmailLog"> <a-icon type="mail" />Email log</a-menu-item>
                  </a-menu>
                  <a-button type="primary" style="margin-left: 8px"> New <a-icon type="down" /></a-button>
                </a-dropdown>
              </span>
          <a-tab-pane v-if="hasPermission('communication.phone-log.list')" key="1" forceRender>
            <span slot="tab">
              <a-icon type="phone" style="font-size: 12px"/>
              Call
            </span>
            <XTable
              ref="phone"
              :model="log_phone"
              :options="{placeholder:'Search Call',noContent: 'No phones',is_load_req:false}"
              @clickRow="(record) =>clickRow(record,'communication.phone-log.get')"
              @refresh="refresh"
              @search="searchLog"
            >
                  <span slot="action" slot-scope="text,record" class="flex space-x-3">
                    <a-dropdown v-if="hasPermission('communication.phone-log.get') || hasPermission('communication.phone-log.delete')">
                      <a-menu slot="overlay">
                        <a-menu-item v-if="hasPermission('communication.phone-log.get')" key="1" @click="openModal(text.record.id,`/communication/phone-log/${text.record.id}/`)"> <feather-icon icon="EditIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>Edit</a-menu-item>
                        <a-menu-item v-if="hasPermission('communication.phone-log.delete')" key="2" @click="deleteItem(text.record.id)"> <feather-icon icon="TrashIcon" svg-classes="text-danger w-4 h-4" class="pr-2"/>Delete</a-menu-item>
                      </a-menu>
                      <a-button style="margin-left: 8px"> Actions <a-icon type="down" /></a-button>
                  </a-dropdown>
                  </span>
              <span slot="matter" slot-scope="text,record" v-if="text.record.matter">
                    {{  text.record.matter.title  }}
                  </span>
              <span slot="from" slot-scope="text,record">
                    <template v-if="text.record.from_user">
                      {{ text.record.from_user.first_name }} {{ text.record.from_user.last_name }}
                    </template>
                  </span>
              <span slot="to" slot-scope="text,record">
                <span v-if="!text.record.to_contacts || text.record.to_contacts.length === 0"></span>
                <span v-else-if="text.record.to_contacts.length === 1"> <!-- style="color: #3A3DBE;" -->
                  {{ text.record.to_contacts[0].full_name }}
                </span>
                <a-popover v-else placement="top">
                  <template slot="content">
                    <ATag v-for="item in text.record.to_contacts">
                      {{ item.full_name }}
                    </ATag>
                  </template>
                  <span>
                    {{ text.record.to_contacts[0].full_name }}, more
                  </span>
<!--                  <a-button type="link">-->
<!--                    {{ text.record.to_contacts[0].full_name }}, more-->
<!--                  </a-button>-->
                </a-popover>
              </span>
              <span slot="time" slot-scope="text,record">
                    {{ text.record.date ? setDateFormat(text.record.date) : '' }}
                  </span>
              <span slot="recorded" slot-scope="text,record">
                    {{ text.record.recorded_time > 0  ? text.record.recorded_time + 'h' : '' }}
                  </span>
            </XTable>
          </a-tab-pane>
          <a-tab-pane v-if="hasPermission('communication.email-log.list')" key="2" forceRender>
                <span slot="tab">
                  <a-icon type="mail" style="font-size: 12px" />
                  Email
                </span>
            <XTable ref="email"
                    :model="log_email"
                    :options="{placeholder:'Search email',noContent: 'No emails',is_load_req: false}"
                    @clickRow="(record) =>clickRow(record,'communication.email-log.get')"
            >
                  <span slot="action" slot-scope="text,record" class="flex space-x-3">
                    <a-dropdown v-if="hasPermission('communication.email-log.get') || hasPermission('communication.email-log.delete')">
                      <a-menu slot="overlay">
                        <a-menu-item v-if="hasPermission('communication.email-log.get')" key="1" @click="openModal(text.record.id,`/communication/email-log/${text.record.id}/`)"><feather-icon icon="EditIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>Edit</a-menu-item>
                        <a-menu-item v-if="hasPermission('communication.email-log.delete')" key="2" @click="deleteItem(text.record.id)"> <feather-icon icon="TrashIcon" svg-classes="text-danger w-4 h-4" class="pr-2"/>Delete</a-menu-item>
                      </a-menu>
                      <a-button style="margin-left: 8px"> Actions <a-icon type="down" /></a-button>
                  </a-dropdown>
                  </span>
              <span slot="matter" slot-scope="text,record" v-if="text.record.matter">
                    {{  text.record.matter.title  }}
                  </span>
              <span slot="from" slot-scope="text,record">
                    <template v-if="text.record.from_user">
                      {{ text.record.from_user.first_name }} {{ text.record.from_user.last_name }}
                    </template>
                  </span>
              <span slot="to" slot-scope="text,record">
                    <ATag v-for="item in listContacts(text.record.to_contacts)">
                      <template v-if="item.person">
                        {{ item.person.first_name }} {{ item.person.last_name }}
                      </template>
                      <template v-else>
                        {{ item.company.name }}
                      </template>
                    </ATag>
              </span>
              <span slot="time" slot-scope="text,record">
                    {{ text.record.date ? setDateFormat(text.record.date) : '' }}
              </span>
            </XTable>
          </a-tab-pane>
        </a-tabs>
      </ACard>
    </vx-card>

    <vs-card class="py-5" v-if="false">
      <div class="container mx-auto text-center">
        <img src="../../../public/7630 (1).svg"  class="w-10/12	 md:w-1/2"/>
        <h2 class="text-2xl font-medium m-5 py-5">No Results Found.</h2>
        <div class="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-4">
          <vs-button color="primary" type="filled" class="font-base" @click="addPhoneLog">New phone log</vs-button>
          <vs-button color="primary" type="filled" class="font-base" @click="addEmailLog">New email log</vs-button>
        </div>
      </div>
    </vs-card>

    <Drawer
      ref="drawer"
      :form="type_log === '1' ? formPhoneLog : formEmailLog"
      :ele="type_log === '1' ? $refs.phone : $refs.email"
      @filter="filterSubmit"
      :query="[
        { field : 'matter', value: type_log === '1'   ? formPhoneLog.getFieldValue('matter')    : formEmailLog.getFieldValue('matter')   , condition:'='},
        { field : 'subject',value: type_log === '1'   ? formPhoneLog.getFieldValue('subject')   : formEmailLog.getFieldValue('subject')  ,  condition: type_log === '1' ? formPhoneLog.getFieldValue('condition_subject') : formEmailLog.getFieldValue('condition_subject') },
        { field : 'from_user',value: type_log === '1' ? formPhoneLog.getFieldValue('from_user') : formEmailLog.getFieldValue('from_user'),  condition: '='},
        { field : 'matter__client', value: type_log === '1' ? formPhoneLog.getFieldValue('contact'): formEmailLog.getFieldValue('contact'),  condition: '='},
        { field : 'created_at', value: period_of_time ? currentDate : undefined ,  condition: '<='},
        { field : 'created_at', value: formPhoneLog.getFieldValue('period_of_time') ? period_of_time : undefined ,  condition: '>='},
      ]"
    >
      <template>
        <selectSearch
          :required="false"
          url="/matter/query/"
          :options="optionSearchMatter"
          field="matter"
          label="Matter"
          class="self-center mt-8 md:mt-0 w-full"
          :is_include_matter="true"
          @selectSearch="handleSearch"
        />
        <a-form-item label="Condition" has-feedback>
          <a-select
            placeholder="condition"
            style="width: 100%"
            allowClear
            class="select"
            v-decorator="['condition_subject']"
          >
            <a-select-option value="=">
              Equal
            </a-select-option>
            <a-select-option value="like">
              Like
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Subject" has-feedback>
          <input
            v-decorator="['subject',{ rules: [{ required: false }] }]"
            placeholder="Enter Subject"
            class="ant-input"
            autocomplete="none"
            :disabled="type_log === '1' ? !formPhoneLog.getFieldValue('condition_subject') :!formEmailLog.getFieldValue('condition_subject')"
          />
        </a-form-item>
        <a-form-item label="Period Of Time" has-feedback>
          <a-select
            style="width: 100%"
            allowClear
            class="select"
            v-decorator="['period_of_time']"
            @select="handleSelectPeriodOfTime"
          >
            <a-select-option value="1,days">
              1 day ago
            </a-select-option>
            <a-select-option value="3,days">
              3 days ago
            </a-select-option>
            <a-select-option value="1,weeks">
              7 days ago
            </a-select-option>
            <a-select-option value="1,months">
              1 month ago
            </a-select-option>
            <a-select-option value="3,months">
              3 months ago
            </a-select-option>
            <a-select-option value="1,years">
              12 months ago
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item class="mt-3">
          <a-radio-group @change="handleRadioGroup" :default-value="1" button-style="solid">
            <a-radio-button :value="1">
              Select Contact
            </a-radio-button>
            <a-radio-button :value="2">
              Select User
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <template v-if="value_filter_radio === 1">
          <selectSearch
            :required="false"
            url="/contact/query/"
            :options="optionSearchContact"
            class="self-center mt-8 md:mt-0 w-full"
          />
        </template>
        <SelectOption v-else url="/account/list/" label="Select User" field="from_user" method="get" placeholder="Find A User" class="w-full"/>
<!--          <SelectOption url="/account/list/" label="To" field="to_users" method="get" placeholder="Find A User" class="w-full"/>-->

        <div
          :style="{
                  position: 'absolute',
                  left: 0,
                  bottom: 0,
                  width: '100%',
                  padding: '10px 16px',
                  background: '#fff',
                  textAlign: 'left',
                  direction:'rtl',
                  zIndex: 1,
                  borderRadius:'3px !important'
               }"
        >
          <a-button type="primary" html-type="submit" style="border-radius:3px !important">
            Save filter
          </a-button>
        </div>
      </template>
    </Drawer>

    <modalActivity ref="modalActivity"/>

    <a-modal centered :width="700" :visible="openEmailLog" title="Email Log" @cancel="onCancelEmailLog">
      <a-form :form="formEmailLog" @submit.prevent="handleSubmitEmailLog">
        <div class="flex flex-col md:flex-row md:space-x-4">
          <selectSearch
            :required="false"
            url="/matter/query/"
            :options="optionSearchMatter"
            class="self-center mt-8 md:mt-0 w-full lg:w-1/2"
            :is_include_matter="true"
            @selectSearch="handleSearch"
          />
          <a-form-item label="Date" has-feedback>
            <a-date-picker
              v-decorator="['date',{ rules: [{ required: false, message: 'Please Enter Date Field.' }] }]"
              :format="dateFormat"
              class="w-full"
            />
          </a-form-item>
        </div>
        <div class="flex flex-col md:flex-row md:space-x-4">
          <SelectOption url="/account/list/" label="Select Users" field="from_user" method="get" placeholder="Find A User" class="w-full"/>
          <selectSearch
            ref="contacts"
            :required="false"
            url="/contact/query/"
            mode="multiple"
            :options="{placeholder: 'Search contact',label: 'Select Contacts',field: 'to_contacts',width: '100%',allow_clear: true}"
            class="self-center mt-8 md:mt-0 w-full"
          />
<!--          <SelectOption url="/account/list/" label="To" field="to_users" mode="multiple" placeholder="Find A User" method="get" class="w-full"/>-->
        </div>

        <a-form-item label="Subject" has-feedback>
          <input
            v-decorator="['subject',{ rules: [{ required: true, message: 'This field is required.' }] }]"
            placeholder="Enter Subject"
            class="ant-input"
            autocomplete="off"
          />
        </a-form-item>

        <a-form-item label="Summary of E-mail" has-feedback>
          <a-textarea
            v-decorator="['message',{ rules: [{ required: true, message: 'This field is required.' }] }]"
            :rows="9"
          />
        </a-form-item>


        <h4>Recorded time</h4>
        <p>Add a time entry to this email log</p>
        <div class="flex flex-col md:flex-row space-x-0 md:space-x-4">
          <a-form-item has-feedback>
            <a-input
              v-decorator="['recorded_time',{ rules: [{ required: false, message: 'Please Enter Time field.' },{ pattern:/[+-]?([0-9]*[.])?[0-9]+/,message:'', required: false }] }]"
              placeholder="recorded Time"
              autocomplete="none"
              :disabled="!stop_time"
              addon-after="hour"
              class="recorded_time"
            />
          </a-form-item>
          <Timer @Timer="(timing)=>timer(timing,formEmailLog,'recorded_time')" @startTime="startTime" :time="time" ref="timer" class="timer mt-5 md:mt-0"/>
        </div>
        <template v-if="is_mode_edit ? hasPermission('communication.email-log.edit') : hasPermission('communication.email-log.create')">
          <a-divider/>
          <div class="flex space-x-2">
            <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">
              Save email log
            </a-button>
            <a-button type="primary" ghost @click="onCancelEmailLog" style="border-radius: 3px !important;">
              Cancel
            </a-button>
          </div>
        </template>
      </a-form>
    </a-modal>

    <a-modal centered :width="700" :visible="openPhoneLog" title="Call Log" @cancel="onCancelPhoneLog">
      <a-form :form="formPhoneLog" @submit.prevent="handleSubmitPhoneLog">

        <div class="flex flex-col md:flex-row md:space-x-4">
          <selectSearch
            :required="false"
            url="/matter/query/"
            :options="optionSearchMatter"
            field="matter"
            label="Matter"
            class="self-center mt-8 md:mt-0 w-full md:w-1/2"
            :is_include_matter="true"
            @selectSearch="handleSearch"
          />
          <a-form-item label="Date" has-feedback>
            <a-date-picker
              v-decorator="['date',{ rules: [{ required: false, message: 'Please Enter Date Field.' }] }]"
              :format="dateFormat"
              class="w-full"
            />
          </a-form-item>
        </div>


        <div class="flex flex-col md:flex-row md:space-x-4">
          <SelectOption url="/account/list/" label="Select users" field="from_user" method="get" placeholder="Find A User" class="w-full"/>
          <selectSearch
            ref="contacts"
            :required="false"
            url="/contact/query/"
            mode="multiple"
            :options="{placeholder: 'Search contact',label: 'Select Contacts',field: 'to_contacts',width: '100%',allow_clear: true}"
            class="self-center mt-8 md:mt-0 w-full"
          />
<!--          <SelectOption url="/account/list/" label="To" field="to_users" mode="multiple" is_initial_value placeholder="Find A User" method="get" class="w-full"/>-->
        </div>
        <a-form-item label="Subject" has-feedback>
          <input
            v-decorator="['subject',{ rules: [{ required: true, message: 'This field is required.' }] }]"
            placeholder="Enter Subject"
            class="ant-input"
            autocomplete="off"
          />
        </a-form-item>

        <a-form-item label="Contents of call" has-feedback>
          <a-textarea
            v-decorator="['message',{ rules: [{ required: true, message: 'This field is required.' }] }]"
            :rows="9"
          />
        </a-form-item>

        <a-divider/>

        <h4>Recorded time</h4>
        <p>Add a time entry to this phone log</p>
        <div class="flex flex-col md:flex-row space-x-0 md:space-x-4">
          <a-form-item has-feedback>
            <a-input
              v-decorator="['recorded_time',{ rules: [{ required: false, message: 'Please Enter Time field.' },{ pattern:/[+-]?([0-9]*[.])?[0-9]+/,message:'', required: false }] }]"
              placeholder="recorded Time"
              autocomplete="none"
              :disabled="!stop_time"
              addon-after="hour"
              class="recorded_time"
            />
          </a-form-item>
          <Timer @Timer="(timing)=>timer(timing,formPhoneLog,'recorded_time')" @startTime="startTime" :time="time" ref="timer" class="timer mt-5 md:mt-0"/>
        </div>
<!--        <div class="flex space-x-4">-->
<!--          <a-form-item>-->
<!--            <a-time-picker use12-hours format="h:mm a" placeholder="10:49 AM" v-decorator="['timepicker',{ rules: [{ required: true, message: '' }] }]"/>-->
<!--          </a-form-item>-->
<!--          <vs-button color="primary" type="filled" class="mb-1" size="medium" icon="play_arrow alarm" style="padding: 8px 20px;">00:00:00</vs-button>-->
<!--        </div>-->

<!--        <a-divider/>-->


<!--          <a-divider/>-->
<!--          <h4>Notifications</h4>-->
<!--          <p>Select firm users to receive notifications about this phone log.</p>-->
<!--          <SelectOption url="/account/list/" label="Notification" :required="true" placeholder="notification" field="notification" method="get" mode="multiple"/>-->

        <template v-if="is_mode_edit ? hasPermission('communication.phone-log.edit') : hasPermission('communication.phone-log.create')">
          <a-divider/>
          <div class="flex justify-start space-x-2">
            <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">
              Save phone log
            </a-button>
            <a-button type="primary" ghost @click="onCancelPhoneLog" style="border-radius: 3px !important;">
              Cancel
            </a-button>
          </div>
        </template>



      </a-form>
    </a-modal>

    <deleteItem :url="`/communication/phone-log/${temp_row}/`" subject="Phone" :ele="$refs.phone" ref="deleteItemPhone" />

    <deleteItem :url="`/communication/email-log/${temp_row}/`" subject="Email" :ele="$refs.email" ref="deleteItemEmail" />
  </div>

</template>

<script>
    import * as TableCol from "./logTbl";
    import * as TableColEmail from "./logEmailTbl";
    import XTable from "../../components/x-table/XTable";
    import SelectOption from "../forms/SelectOptionSingle"
    import selectSearch from "@/views/forms/selectSearch";
    import Timer from "@/layouts/components/timer/Timer";
    import axios from "@/axios";
    import mixin from "../mixin/mixin"
    import deleteItem from "./deleteItem";
    import Drawer from '../drawer/Drawer'
    import modalActivity from '../modal/ModalActivity'
    import moment from 'moment'

    export default {
        name: "Communications",
        mixins:[mixin],
        props:{
          hasFilterMatter:{
            type: Boolean,
            default: false
          }
        },
        components:{
          XTable,
          SelectOption,
          Timer,
          selectSearch,
          deleteItem,
          Drawer,
          modalActivity
        },
        data(){
          return{
            log_phone:null,
            log_email:null,
            secure:null,
            openSecureMsg: false,
            openEmailLog: false,
            openPhoneLog: false,
            formEmailLog: this.$form.createForm(this, { name: 'coordinated' }),
            formPhoneLog: this.$form.createForm(this, { name: 'coordinated' }),
            time: 0,
            temp_row: null,
            delete_item_phone: false,
            type_log: null,
            type_communication:'1',
            is_mode_edit: false,
            matter_value: null,
            rows: undefined,
            type_log_recorded_time: 'All',
            stop_time: true,
            period_of_time: null,
            value_filter_radio: 1
          }
        },

        computed:{

        },

        methods:{

          handleRadioGroup({target:{value}}){
            this.value_filter_radio = value
          },

          startTime(){
            this.stop_time = false
            // if(this.formPhoneLog.getFieldValue('recorded_time'))
            //   this.$refs.timer.formattedElapsedTime = this.formPhoneLog.getFieldValue('recorded_time') * 3600
          },

          refresh(){
            this.type_log_recorded_time = 'All'
          },

          filterSubmit(){
            this.type_log_recorded_time = 'none'
          },

          searchLog(search){
            search === null || search === '' ? this.type_log_recorded_time = 'All' : this.type_log_recorded_time = 'none'
          },

          showDrawer(){
            this.type_communication === '1' ? this.$refs.drawer.visible_drawer = true : this.$refs.drawerMessage.visible_drawer = true
          },

          async filterStatus(condition,value){
            this.checkPagenation(this.$refs.phone)
            condition === 'all' ? this.$refs.phone.query.query = undefined : this.$refs.phone.query.query = [{ field:'recorded_time',condition:condition,value: value }]
            await this.$refs.phone.fetch()
          },

          getDataRow(data){
            data.from_user ? data.from_user = data.from_user.id : data.from_user = undefined
            data.to_users.length ? data.to_users = data.to_users.map(item=>item.id) : data.to_users = undefined
            data.matter ? data.matter = data.matter.title : data.matter = undefined
            data.to_contacts = data.to_contacts && data.to_contacts.length ? data.to_contacts.map(({id})=> id) : []
            if(this.type_log === '1'){
              const second = data.recorded_time * 3600
              this.$refs.timer.formattedElapsedTime = second
              this.time = data.recorded_time
            }
            const which_form = this.type_log === '1' ? this.formPhoneLog : this.formEmailLog
            which_form.setFieldsValue(data)
          },

          clickTime(){
            this.is_click_add_time = false
            this.$refs.modalActivity.openActivities = true
          },

          clickRow(record,permission){
            if (this.hasPermission(permission)){
              this.is_mode_edit = true
              this.temp_row = record.id
              this.type_log === '1' ? this.openPhoneLog = true : this.openEmailLog = true
              const url = this.type_log === '1' ? `/communication/phone-log/${record.id}/` : `/communication/email-log/${record.id}/`
              this.$nextTick(()=> this.getData(url))
            }
          },

          async getData(url){
            try{
              this.$vs.loading()
              const { data } = await axios.get(url)
              this.rows = data
              this.$nextTick(()=> this.getDataRow(data))
            }catch (e){
              throw e
            }finally {
              this.$vs.loading.close()
            }
          },

          openModal(id,url){
            this.type_log === '1' ? this.openPhoneLog = true : this.openEmailLog = true
            this.is_mode_edit = true
            this.temp_row = id
            this.getData(url)
          },

          deleteItem(id){
            this.temp_row = id
            this.type_log === '1' ? this.$refs.deleteItemPhone.open = true : this.$refs.deleteItemEmail.open = true
          },

          changeTab(key){
            this.type_log = key
          },

          handleSubmitEmailLog(){
            this.formEmailLog.validateFields(async (err,values)=>{
              if(!err){
                try{
                  this.$vs.loading()
                  values.contact = undefined
                  if(!values.from_user) values.from_user = null
                  if(this.is_mode_edit){
                    // this.matter_value ? values.matter = this.matter_value : this.rows.matter.id ? values.matter = this.rows.matter.id : values.matter = undefined
                    this.matter_value ? values.matter = this.matter_value : !values.matter ? values.matter = null : values.matter = this.rows.matter.id
                    await axios.put(`/communication/email-log/${this.temp_row}/`, values)
                  }else {
                    await axios.post(`/communication/email-log/`, values)
                  }
                  this.formEmailLog.resetFields()
                  this.openEmailLog = false
                  if (this.hasPermission('communication.email-log.list')) this.type_log = '2'
                  await this.$notification['success']({
                    message: 'Success',
                    description: `Log Email ${this.is_mode_edit ? 'updated' : 'created'}.`
                  });
                  this.$refs.email.query.query = []
                  this.$refs.email.fetch().then(()=>{})
                }catch(e){
                  this.openEmailLog = true
                  this.$notification['error']({
                    message: 'Error',
                    description: `Please try again.`,
                  });
                  throw e
                }finally {
                  this.$vs.loading.close()
                }
              }
            })
          },

          handleSubmitPhoneLog(){
            this.formPhoneLog.validateFields(async (err,values)=>{
              if (!err) {
                try {
                  this.$vs.loading()
                  values.contact = undefined
                  if(!values.from_user) values.from_user = null
                  if(this.is_mode_edit){
                    this.matter_value ? values.matter = this.matter_value : !values.matter ? values.matter = null : values.matter = this.rows.matter.id
                    // this.matter_value ? values.matter = this.matter_value : this.rows.matter.id ? values.matter = this.rows.matter.id : values.matter = undefined
                    await axios.put(`/communication/phone-log/${this.temp_row}/`, values)
                  }else{
                    await axios.post(`/communication/phone-log/`, values)
                  }
                  this.formPhoneLog.resetFields()
                  this.openPhoneLog = false
                  if (this.hasPermission('communication.phone-log.list')) this.type_log = '1'
                  await this.$notification['success']({
                    message: 'Success',
                    description: `Log Phone ${this.is_mode_edit ? 'updated' : 'created'}.`,
                  });
                  this.$refs.phone.fetch().then(()=>{})
                } catch (e) {
                  this.openPhoneLog = true
                  this.$message.error('Server Error')
                  throw new Error(e)
                } finally {
                  this.$vs.loading.close()
                }
              }
            })
          },

          onCancelSecure(){
            this.openSecureMsg = false
            setTimeout(()=>this.form.resetFields(),200)
          },

          addEmailLog(){
            this.is_mode_edit = false
            this.openEmailLog = true
          },

          onCancelEmailLog(){
            this.openEmailLog = false
            setTimeout(()=>this.formEmailLog.resetFields(),200)
          },

          addPhoneLog(){
            this.is_mode_edit = false
            this.openPhoneLog = true
            this.formPhoneLog.resetFields()
            this.$refs.timer.formattedElapsedTime = 0
          },

          onCancelPhoneLog(){
            this.openPhoneLog = false
            setTimeout(()=>this.formPhoneLog.resetFields(),200)
          }
        },

        async created() {
            this.log_phone = TableCol.default
            this.log_email = TableColEmail.default
            const permissions = await this.$store.state.permissions
            if (permissions !== undefined) {
              if(this.hasPermission('communication.phone-log.list')) this.type_log = '1'
              else if(this.hasPermission('communication.email-log.list')) this.type_log = '2'
            }
            if (this.hasFilterMatter) {
              this.$refs.phone.query.query = [{ field: 'matter__id', condition: '=', value: this.$route.params.id }]
              this.$refs.email.query.query = [{ field: 'matter__id', condition: '=', value: this.$route.params.id  }]
            }
            if(this.$refs){
              await this.$refs.phone.fetch()
              await this.$refs.email.fetch()
            }
        },

        async mounted() {
          this.is_click_add_time = true
        }
    }

</script>

<style>
  @import "../style/style.css";

  [dir] .vs-button.small{
    border-radius: 6px !important;
    padding: 12px !important;
  }
  .ant-btn-link,.text-indigo-600{
    color: #3A3DBE
  }
  .vs-button.small > .vs-button-text.vs-button--text{
    /*font-size: 1.3em !important;*/
  }
  [dir] .ant-input,[dir] .ant-time-picker-input{
    border-radius: 3px !important;
  }
  [dir] .select .ant-select-selection.ant-select-selection--single{
    border-radius: 3px !important;
  }
  [dir=ltr] .ant-modal-footer{
    display: none !important;
  }
  [dir] .vx-navbar-wrapper {
    z-index: 2 !important;
  }
  .ant-time-picker{
    width: 100% !important;
  }
  .communication{
    width: 70%;
  }
  [dir=ltr] .ant-tabs-nav .ant-tabs-tab .anticon{
    margin-right: 0 !important;
  }
  [dir] .ant-alert-error{
    /*background-color: #f4f7f9 !important ;*/
  }

  .slide-leave-active,
  .slide-enter-active {
    transition: all 0.3s ease;
  }
  .slide-enter {
    transform: translate(-100%, 0);
  }
  .slide-leave-to {
    transform: translate(250%, 0);
  }


</style>
